import Licencia from '../../spa/licencia/licencia';

export default {
    path: 'licencia',
    name: 'licencia',
    component: Licencia,
};


// WEBPACK FOOTER //
// ./src/config/router/licencia.js